import React,  { useContext, useEffect,useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Box, Tabs, Tab, Button } from '@material-ui/core';
import { useStyles } from '../styles';
import HomeIcon from '@mui/icons-material/Home';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Store } from '../Store';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';
import Axios from 'axios';
import config,{ getParameterByName,merchantCode} from '../util';
import { addToOrder, clearOrder, removeFromOrder } from "../actions";

const MyOrders = () => {
  const { state, dispatch } = useContext(Store);
  const styles = useStyles();
  const history = useHistory();
  const [myorders, setMyOrders] = useState([]);
  const [tabSel, setTabSel] = React.useState(0);
  let { setting } = state.userSetting;
  if(!setting){
    setting = JSON.parse(localStorage.getItem("userInfo"));
  }
  const baseURL = config.baseURL
  const customersInfo =sessionStorage.getItem("customerInfo")?JSON.parse(sessionStorage.getItem("customerInfo")):"";
 useEffect(() => {
      let cusId = customersInfo.customer.id||customersInfo.customer._id;

      let subPath = `/api/clover/ecom/orders/customer/${cusId}?merchantCode=${merchantCode}`;
      Axios.get (`${baseURL}${subPath}`).then( res => {
        console.log(res);
        setMyOrders(res.data); 
      });
      
 },[])
  const handleTabChange = (event, newValue) => {
    setTabSel(newValue);
  }

  const reorderItems = (oldOrder) => {
    let items = JSON.parse(oldOrder.order).orderItems;
    items.map(itm => addToOrder(dispatch, itm));
  }

  const goto = (subpath) => {
    history.push('/'+subpath+'?' + window.location.href.split('?')[1]);
  }

  return (
    <Box
      className={styles.root}
      style={{ padding: "0px!important", backgroundColor: setting.themeColor }}
    >
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, pt: 2, pb: 1 }}>
        <ArrowBackIosNewIcon 
          style={{color: setting.themeTxtColor}} 
          onClick={() => history.goBack()}
        />
        <Typography variant="h6" style={{ color: setting.themeTxtColor, fontFamily: setting.themePrimaryFontFam }}>
          My Previous Orders
        </Typography>
        <Box style={{width: "24px"}} /> {/* Spacer for alignment */}
      </Box>

      <Box style={{ 
        padding: "20px", 
        minHeight: "calc(100vh - 180px)",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}>
       {myorders.map(mo => {
        let ord = JSON.parse(mo.order);
        return <div style={{padding:"10px", margin:"10px", background:setting.themeTxtColor, borderRadius:"8px",width:"100%"}}>
              <h3 style={{fontColor:setting.themeColor}}>{ord.orderItems[0].name} <span style={{fontSize:"0.8em"}}>{ord.orderItems.length>1 && (`+ ${ord.orderItems.length -1} Items`)}</span>  </h3>

              <span style={{fontColor:"#fff",position:"absolute",marginBottom:"10px"}}>{'Order date: '+ mo.updatedAt.split('T')[0]}</span>
               <Button
                onClick={()=> reorderItems(mo)}
                variant="contained"
                size="large"
                style={{
                  backgroundColor: setting.themeTxtColor, 
                  color: setting.themeColor,
                  fontWeight:'500',
                  borderRadius:"8px",
                  padding: '5px 8px',
                  maxWidth:"150px",
                  margin:"20px",
                  fontSize:"0.9em",
                  border:"1px solid "+setting.themeColor,
                  float:"right"
                }}
              >
                REORDER
              </Button>
        </div>

       })}
      </Box>

      <Tabs 
        style={{
          backgroundColor: setting.themeTxtColor,
          borderTop: "2px solid " + setting.themeColor,
          padding:"6px"
        }} 
        className="footer-tab" 
        value={tabSel} 
        onChange={handleTabChange} 
        aria-label="tabs footer"
      >
        <Tab 
          style={{
            background: tabSel==0 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==0 ? '#fff' : ""
          }} 
          onClick={() => goto('order')} 
          icon={<HomeIcon />}  
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==1 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==1 ? '#fff' : "",
            position: 'relative',
          }} 
          onClick={() => goto('cart')} 
          icon={
            <Box sx={{ position: 'relative', padding: '4px' }}>
              <ShoppingCartIcon />
             
               {state.order.itemsCount > 0 && (
                          <span className={"badge"} style={{background:'red',color:'#fff'}}>
                            {state.order.itemsCount}
                          </span>
                        )}
             
            </Box>
          }
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==2 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==2 ? '#fff' : ""
          }} 
          onClick={() => {
            setTabSel(2);
            goto('favourites');
          }} 
          icon={<FavoriteIcon />} 
          label="" 
        />
        <Tab
          style={{
            background: tabSel==3 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==3 ? '#fff' : "",
            position: 'relative'
          }}
          onClick={() => {
            history.push('/profile?' + window.location.href.split("?")[1]);
          }}
          icon={<AccountCircleIcon />}
          label="" 
        />
      </Tabs>
    </Box>
  );
};

export default MyOrders;
